import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ClFormGroup from '../ClFormGroup';
import { VNodeData, CreateElement } from 'vue';
import { ClRadioGroupProps } from '.';

@Component({
  model: {
    prop: 'checked',
    event: 'input'
  }
})
export default class ClRadioGroup extends Vue implements ClRadioGroupProps {
  @Prop({
    default: null,
    type: [String, Object, Number, Boolean]
  })
  public checked!: string | object | number | boolean;

  public checkedState: string | object | number | boolean = this.checked;

  @Prop(String)
  public id!: string;

  public isGroup: boolean = true;

  @Prop(String)
  public name!: string;

  @Prop({
    default: false,
    type: Boolean
  })
  public row!: boolean;

  @Watch('checked')
  watchChecked() {
    this.checkedState = this.checked;
  }

  @Watch('checkedState')
  watchCheckedState(newVal: boolean) {
    this.$emit('input', newVal);
  }

  render(h: CreateElement) {
    const data: VNodeData = {
      class: {
        'cl-radio-group': true,
        'cl-radio-group--row': this.row
      },
      attrs: {
        role: 'radiogroup',
        tabindex: '-1'
      }
    };
    return h(ClFormGroup, data, this.$slots.default);
  }
}
